import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import $ from "jquery";
import Flickity from 'react-flickity-component'
import { NavLink } from 'react-router-dom';
import { Badge, Divider, Input, InputGroup, List, Drawer, Animation, Button } from 'rsuite';


export default class Dashboard extends React.Component {



    constructor(props) {
        super(props);
        this.state = {
            course: null,
            diet: null,
            training: null,
            searchVal: null,
            SearchBox: false,

        };
    }


    // ---------------- componentDidMount--------------------------
    componentDidMount() {

        Send('page/dashboard', "", true).then((res) => {
            this.setState({
                course: res.data.course,
                diet: res.data.diet,
                training: res.data.training,
            });
        }).catch((err) => { });


    }



    render() {

        H1.page_name("داشبورد");

        return (


            <div className="h-100 mt-4">



                <div className="c-row">
                    <Animation.Slide in={true} placement="right">
                        <img src={localStorage.getItem('avatar')} width="48" height="48" className='float-start me-3 rounded-50 rounded-circle' />
                    </Animation.Slide>
                    <Animation.Slide in={true} placement="top">
                        <div>

                            <div className='cc-2 pt-1 fs-12'>خوش آمدید</div>
                            <div className='fs-5 fs-18'>{localStorage.getItem("name")}


                            <NavLink className='float-end  fs-18 cc-3 py-1' aria-expanded="false" exact="true" to="/notfy">
                        

                        
                            {this.state.new_notfy ?
                                    <Badge color='blue' >
                                          <span className="icon-Notification-Off"></span>
                                    </Badge>

                                    :
                                      <span className="icon-Notification-Off"></span>
                                }

                                 
                    
                            </NavLink>
                                {/* <Button appearance="subtle" className='float-end  fs-18 cc-3 py-1' onClick={() => this.setState({ SearchBox: true })}>
                                    <span className="icon-Search"></span>
                                </Button> */}


                            </div>
                        </div>

                    </Animation.Slide>

                </div>







                <Drawer size='md' placement='top' open={this.state.SearchBox} onClose={() => this.setState({ SearchBox: false })}>
                    <Drawer.Header>
                        <Drawer.Title>

                            <InputGroup inside >
                                <Input onChange={(val) => H1.FilterElm('.sr_item', val)} placeholder="جستجو ..." />
                                {/* <InputGroup.Button>
                         <span className="icon-Search"></span> 
                        </InputGroup.Button> */}
                            </InputGroup>

                        </Drawer.Title>
                        <Drawer.Actions>
                        </Drawer.Actions>
                    </Drawer.Header>
                    <Drawer.Body className='px-4'>


                        <List size="sm" bordered>

                            {this.state.course && this.state.course.map((item, index) => [
                                <NavLink exact="true" to={'/course/' + item.id} className='cc-3 sr_item'>    <List.Item>  <span className="icon-Courses cc-1"></span> <Divider vertical />    {item.name}  </List.Item> </NavLink>
                            ])}

                            {this.state.diet && this.state.diet.map((item, index) => [
                                <NavLink exact="true" to={'/diet/' + item.id} className='cc-3 sr_item'>    <List.Item>  <span className="icon-diets cc-1"></span> <Divider vertical />    {item.name}  </List.Item> </NavLink>
                            ])}


                            {this.state.training && this.state.training.map((item, index) => [
                                <NavLink exact="true" to={'/training/' + item.id} className='cc-3 sr_item'>    <List.Item>  <span className="icon-trainings cc-1"></span> <Divider vertical />    {item.name}  </List.Item> </NavLink>
                            ])}



                            <NavLink exact="true" to='/cart/sub' className='cc-3 sr_item'>    <List.Item>  <span className="icon-Basket cc-green"></span> <Divider vertical />  تمدید اشتراک  </List.Item> </NavLink>
                            <NavLink exact="true" to='/cart' className='cc-3 sr_item'>    <List.Item>  <span className="icon-Basket cc-green"></span> <Divider vertical />  سبد خرید </List.Item> </NavLink>
                            <NavLink exact="true" to='/profile/edit' className='cc-3 sr_item'>    <List.Item>  <span className="icon-Setting"></span> <Divider vertical />   ویرایش مشخصات  </List.Item> </NavLink>
                            <NavLink exact="true" to='/notfy' className='cc-3 sr_item'>    <List.Item>  <span className="icon-Setting"></span> <Divider vertical />    اعلانات  </List.Item> </NavLink>
                            <NavLink exact="true" to='/orders' className='cc-3 sr_item'>    <List.Item>  <span className="icon-Profile cc-red"></span> <Divider vertical />    دوره‌های من </List.Item> </NavLink>
                            <NavLink exact="true" to='/profile/transaction' className='cc-3 sr_item'>    <List.Item>  <span className="icon-Setting"></span> <Divider vertical />    سابقه پرداخت‌ها  </List.Item> </NavLink>





                        </List>

                    </Drawer.Body>
                </Drawer>



                {this.state.course &&

                    <>


                        <div className="c-row mt-5">


                            <div className='mb-3'> <span className="fs-16">جدیدترین‌ها</span>
                                {/* <Button appearance="link" className='cc-1 float-end p-0 fs-12'> مشاهده همه </Button>  */}
                            </div>



                            <Flickity
                                className={'carousel'} // default ''
                                elementType={'div'} // default 'div'
                                options={{
                                    contain: true,
                                    pageDots: false,
                                    prevNextButtons: false,
                                    rightToLeft: true
                                }} // takes flickity options {}
                                disableImagesLoaded={false} // default false
                                reloadOnUpdate // default false
                                static // default false
                            >



                                {this.state.course.slice(0, 1).map((item, index) => [

                                    <NavLink exact="true" to={'/course/' + item.id} key={'s' + index}>
                                        <div className='cours_item_swipe bg-white br-16'>
                                            <img className='cover' src={item.cover ?? '/img/not.png'} width="192" height="128" />
                                            <div className="info px-4 py-3 text-start">

                                                <div className="text-nowrap text-black"> {item.name}
                                                    {item.is_live == 1 &&
                                                        <Badge className='px-2 ms-1' content="لایو" />
                                                    }
                                                </div>



                                                <div className="cc-1 mt-3">
                                                    
                                                {item.pay === "sub" ? 
                                                    'اشتراک ویژه'
                                                : <> {H1.formatNumber(item.price)} تومان </>
                                            }
                                                     
                                                </div>

                                            </div>
                                        </div>
                                    </NavLink>



                                ])}




                                {this.state.diet.slice(0, 1).map((item, index) => [

                                    <NavLink exact="true" to={'/diet/' + item.id} key={'s' + index}>
                                        <div className='cours_item_swipe bg-white br-16'>
                                            <img className='cover' src={item.cover ?? '/img/not.png'} width="192" height="128" />
                                            <div className="info px-4 py-3 text-start">
                                                <div className="text-nowrap text-black"> {item.name} </div>
                                                <div className="cc-1 mt-3"> {H1.formatNumber(item.price)} تومان</div>

                                            </div>
                                        </div>
                                    </NavLink>

                                ])}



                                {this.state.training.slice(0, 1).map((item, index) => [

                                    <NavLink exact="true" to={'/training/' + item.id} key={'s' + index}>
                                        <div className='cours_item_swipe bg-white br-16'>
                                            <img className='cover' src={item.cover ?? '/img/not.png'} width="192" height="128" />
                                            <div className="info px-4 py-3 text-start">
                                                <div className="text-nowrap text-black"> {item.name} </div>
                                                <div className="cc-1 mt-3"> {H1.formatNumber(item.price)} تومان</div>
                                            </div>
                                        </div>
                                    </NavLink>

                                ])}



                            </Flickity>






                        </div>


                        {/* --------------------------------- course ---------------------------------  */}


                        <div className="c-row mt-5">

                            <div className='mb-3'> <span className="fs-16"> کلاس‌های آنلاین </span>
                                {/*                             
                              <Button appearance="link" className='cc-1 float-end p-0 fs-12'> مشاهده همه </Button>  */}

                            </div>


                            {this.state.course.map((item, index) => [
                                <NavLink exact="true" to={'/course/' + item.id} key={'l' + index}>
                                    <div className='cours_item bg-white br-16 mb-3'>
                                        <div className="cover-box">
                                            <img className='cover' src={item.cover ?? '/img/not.png'} />
                                        </div>
                                        <div className="info px-3 py-4">
                                            <div className="fs-10 cc-1">

                                                {item.pay === "sub" ? 'اشتراک ویژه' : 'خرید نقدی'}

                                            </div>
                                            <div className="py-2"> {item.name} </div>
                                            {item.archive_count > 0 &&
                                                <div className="fs-10 cc-2">
                                                    {item.archive_count} جلسه   <span className='mx-1'>●</span> {H1.TimeConvert(item.archive_time, ['h', 'm'])}
                                                </div>
                                            }

                                            
                                            {item.pay !== "sub" &&
                                                <div className="cc-1 mt-3"> {H1.formatNumber(item.price)} تومان</div>
                                            }


                                        </div>
                                    </div>
                                </NavLink>
                            ])}


                        </div>



                        {/* --------------------------------- diet ---------------------------------  */}




                        <div className="c-row mt-5">

                        <div className='mb-3'> <span className="fs-16"> برنامه‌های غذایی تو </span>
                                {/*                             
                              <Button appearance="link" className='cc-1 float-end p-0 fs-12'> مشاهده همه </Button>  */}

                            </div>


                            {this.state.diet.map((item, index) => [
                                <NavLink exact="true" to={'/diet/' + item.id} key={'D' + index}>
                                    <div className='cours_item bg-white br-16 mb-3'>
                                        <div className="cover-box">
                                            <img className='cover' src={item.cover ?? '/img/not.png'} />
                                        </div>
                                        <div className="info px-3 py-4">
                                            <div className="fs-10 cc-1">

                                                {item.pay === "sub" ? 'اشتراک ویژه' : 'خرید نقدی'}

                                            </div>
                                            <div className="py-2"> {item.name} </div>
                                            {item.archive_count > 0 &&
                                                <div className="fs-10 cc-2">
                                                    {item.archive_count} جلسه   <span className='mx-1'>●</span> {H1.TimeConvert(item.archive_time, ['h', 'm'])}
                                                </div>
                                            }
                                            <div className="cc-1 mt-3"> {H1.formatNumber(item.price)} تومان</div>
                                        </div>
                                    </div>
                                </NavLink>
                            ])}


                        </div>




                        {/* --------------------------------- training ---------------------------------  */}



                        <div className="c-row mt-5">
                        <div className='mb-3'> <span className="fs-16">برنامه‌های تمرینی تو</span>

      
                                {/*                             
                        <Button appearance="link" className='cc-1 float-end p-0 fs-12'> مشاهده همه </Button>  */}

                            </div>


                            {this.state.training.map((item, index) => [
                                <NavLink exact="true" to={'/training/' + item.id} key={'T' + index}>
                                    <div className='cours_item bg-white br-16 mb-3'>
                                        <div className="cover-box">
                                            <img className='cover' src={item.cover ?? '/img/not.png'} />
                                        </div>
                                        <div className="info px-3 py-4">
                                            <div className="fs-10 cc-1">

                                                {item.pay === "sub" ? 'اشتراک ویژه' : 'خرید نقدی'}

                                            </div>
                                            <div className="py-2"> {item.name} </div>
                                            {item.archive_count > 0 &&
                                                <div className="fs-10 cc-2">
                                                    {item.archive_count} جلسه   <span className='mx-1'>●</span> {H1.TimeConvert(item.archive_time, ['h', 'm'])}
                                                </div>
                                            }

                                            <div className="cc-1 mt-3"> {H1.formatNumber(item.price)} تومان</div>

                                        </div>
                                    </div>
                                </NavLink>
                            ])}


                        </div>



                    </>
                }

            </div>


        )
    }
}

